import React from 'react'
import { px } from '../utils'

export default ({ imageUrl, style = {}, x = 0, y = 0 }: { imageUrl: string; style?: Object; x: number; y: number }) => <img src={imageUrl} draggable={false} onDragStart={e => e.preventDefault()} onDoubleClick={e => e.preventDefault()} onClick={e => e.preventDefault()} style={{ userSelect: 'none', position: 'absolute', top: px(y), left: px(x), ...style }} alt="" />
